// tl -carrier router

import Layout from "@/layout";

export default {
  path: "/load-board",
  component: Layout,
  meta: { title: "Search Loads", icon: "search-console" },
  children: [
    {
      path: "search-loads",
      name: "searchLoads",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: { title: "Search Console", system: "carrier" },
    },
    {
      path: "search-loads/result",
      name: "searchLoads",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: { title: "Search Results", system: "carrier", showBack: true },
      hidden: true,
    },
    {
      path: "post-truck",
      name: "postTruck",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Post Truck",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "connect",
      name: "connect",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Connected Brokers",
        system: "carrier",
      },
    },
    {
      path: "connect/loadsmart",
      name: "profile",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Board",
        system: "carrier",
        keepAlive: true,
      },
      hidden: true,
    },
    {
      path: "load-alert",
      name: "loadAlert",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Alert",
        system: "carrier",
        keepAlive: true,
      },
    },
    {
      path: "load-alert/load-list",
      name: "loadAlert",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Alert",
        system: "carrier",
        keepAlive: true,
      },
      hidden: true,
    },
  ],
};
